/* wp-text.js - turning what WordPress serves into what a person reads.
   ----------------------------------------------------------------------------
   WordPress serves a post title as RENDERED HTML in `title.rendered`. It has
   been through `wptexturize`, so a typed apostrophe comes back as a curly one,
   and then through escaping, so that curly apostrophe arrives on the wire as
   the six characters `&#8217;`. An ampersand arrives as `&amp;`.

   Put straight into a React text node, those six characters are exactly what
   the user sees: "Optimisation de l&#8217;Organisation". That is the visible
   half of the bug. The worse half is the editor, where the same string lands in
   the title input and is SAVED BACK as text, so WordPress stores the entity
   rather than the character and the title in the database stops being the
   title. Saving again cannot fix it, which is why re-saving the post changed
   nothing.

   So anything taken out of `*.rendered` and shown as text is decoded first.
   `backend/lib/coverage.js` has the same function server-side (`plainTitle`),
   pinned by tests; this is its browser twin and has to agree with it. */

/**
 * A rendered WordPress title (or any `{ rendered }` field) as plain text.
 * Accepts the field object or the string, and returns "" for neither.
 *
 * Tags are dropped before decoding, because a `<em>` in a title is markup
 * rather than part of the words; the decode itself happens inside a textarea,
 * where the browser's own parser resolves every named and numeric entity and
 * nothing in the string can execute.
 *
 * Whitespace is deliberately NOT collapsed: a non-breaking space before a "?"
 * is French typography that WordPress put there on purpose, and this string is
 * saved back as the title.
 */
export function plainTitle(value) {
  const raw = typeof value === "string"
    ? value
    : (value && typeof value === "object" ? String(value.rendered || "") : "");
  if (!raw) return "";
  const noTags = raw.replace(/<[^>]*>/g, "");
  if (!noTags.includes("&")) return noTags;
  const el = document.createElement("textarea");
  el.innerHTML = noTags;
  return el.value;
}
